<template>
  <div class="bottom">
    <img src="../assets/img/Complaint.png" class="bottom-img" @click="webToAndroid('toComplaint')">
    <img src="../assets/img/service.png" class="bottom-img" @click="webToAndroid('toCustomer')">
  </div>
</template>

<script>
export default {
  name: "Service",
  method: function () {
    window.showInfoFromJs = this.showInfoFromJs
  },
  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    webToAndroid(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      }

      //调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value)
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value)
    }
  },

}
</script>

<style scoped>

.bottom {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 10px;
  z-index: 999;
}

.bottom-img {
  width: 35%; /* 根据需要调整图片的宽度 */
  height: auto; /* 根据需要调整图片的高度 */
}
</style>



// WEBPACK FOOTER //
// src/page/Service.vue